<template>
    <div>
        <pc-label
            class="collapsible-label py-1"
            bold
            v-bind:label="label"
            v-on:click="toggleCollapse">
            <pc-bs-icon
                class="ms-1"
                name="caret-right-fill"
                v-bind:rotate-on="!isCollapsed" />
        </pc-label>
        <pc-transition v-bind:transition="TRANSITION_TYPE.slide">
            <div v-if="!isCollapsed">
                <slot />
            </div>
        </pc-transition>
    </div>
</template>

<script setup>
    import { ref, inject, computed, onBeforeMount } from "vue";
    import { PAGE_APP_SYMBOL } from "_Main/injectionSymbols";
    import { TRANSITION_TYPE } from "Util/animations";

    const app = inject(PAGE_APP_SYMBOL);

    const props = defineProps({
        label: { type: String, required: true },
        stateKey: { type: String, required: true }
    });

    onBeforeMount(() => {
        isCollapsedInternal.value = localStorage.getItem(storageKey.value) === "true";
    });

    const isCollapsedInternal = ref(false);
    const isCollapsed = computed({
        get: () => isCollapsedInternal.value,
        set: (value) => {
            isCollapsedInternal.value = value;
            localStorage.setItem(storageKey.value, value);
        }
    });

    const storageKey = computed(() => {
        const userId = app.LoggedInUser.PublicId;
        return `collapsible-label_${props.stateKey}_${userId}`;
    });

    function toggleCollapse() {
        isCollapsed.value = !isCollapsed.value;
    }
</script>

<style lang="scss" scoped>
    .collapsible-label {
        cursor: pointer;
    }
</style>
